import { useNavigate, useParams } from 'react-router-dom'
import EmailIllustration from '../../assets/mail.png'
import { useVerifyEmail } from './api'
import { useSnackbarManager } from '../../components/common/snackbar'

export default function VerifyEmail() {
  const { id } = useParams<{ id: string }>()
  const { mutate, isLoading, isError, isSuccess } = useVerifyEmail()
  const navigate = useNavigate()

  const { enqueueSnackbar } = useSnackbarManager()

  const handleVerifyClick = () => {
    if (id) {
      mutate(id, {
        onSuccess: (data: any) => {
          enqueueSnackbar(data.message || 'Email verified successfully!', {
            variant: 'success',
          })
          setTimeout(() => {
            navigate('/login')
          }, 2500)
        },
        onError: () => {
          enqueueSnackbar('Verification failed. Please try again.', {
            variant: 'error',
          })
        },
      })
    } else {
      enqueueSnackbar('Invalid verification link.', {
        variant: 'warning',
      })
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-4">
      <div className="bg-white border border-gray-200 p-8 rounded-2xl shadow-lg w-full max-w-xl text-center mb-[100px]">
        <img
          src={EmailIllustration}
          alt="Verify Email"
          className="w-32 h-32 mx-auto mb-6"
        />

        <h2 className="text-2xl font-bold text-gray-800 mb-2">
          Verify Your Email Address
        </h2>

        <p className="text-gray-600 mb-6">
          We&apos;ve sent a verification link to your email.
        </p>

        {isLoading && <p className="text-blue-500 mb-4">Verifying...</p>}
        {isSuccess && (
          <p className="text-green-600 mb-4">Email verified successfully!</p>
        )}
        {isError && (
          <p className="text-red-600 mb-4">
            Failed to verify. Please try again.
          </p>
        )}

        <button
          type="button"
          className="bg-orange-500 hover:bg-orange-600 transition-all duration-200 text-white font-semibold text-sm py-3 px-6 rounded-lg w-full max-w-xs mx-auto"
          onClick={handleVerifyClick}
        >
          Verify Email
        </button>
      </div>
    </div>
  )
}
